import { Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { IonItem, IonLabel, IonInput, IonButton, IonIcon } from '@ionic/angular/standalone';

@Component({
  selector: 'x-input',
  standalone: true,
  imports: [ReactiveFormsModule, IonItem, IonLabel, IonInput, IonButton, IonIcon],
  templateUrl: './x-input.component.html',
  styleUrl: './x-input.component.scss'
})
export class XInputComponent {
  label = input.required<string>();
  type = input<string>('text');
  placeholder = input<string>('');
  inputmode = input<string>('text');
  autocomplete = input<string>('off');
  control = input.required<FormControl>();
  errorMessages = input<Record<string, string>>({});
  showPasswordToggle = input<boolean>(false);
  slotEnd = input<any>(null);

  passwordVisible = output<boolean>();
  
  protected passwordVisibleState = false;

  get inputType(): string {
    if (this.type() === 'password' && this.showPasswordToggle()) {
      return this.passwordVisibleState ? 'text' : 'password';
    }
    return this.type();
  }

  togglePasswordVisibility(): void {
    this.passwordVisibleState = !this.passwordVisibleState;
    this.passwordVisible.emit(this.passwordVisibleState);
  }

  getErrorMessage(): string | null {
    const ctrl = this.control();
    if (!ctrl || !ctrl.errors || !ctrl.touched) {
      return null;
    }

    const errors = this.errorMessages();
    const errorKey = Object.keys(ctrl.errors)[0];
    return errors[errorKey] || `Invalid ${this.label().toLowerCase()}`;
  }
}
